export default __webpack_public_path__ + "static/media/rosa.ee12f804.png";